/* eslint-disable prettier/prettier */
/* eslint-disable quotes */
export default {
  es: 'Spanish',
  selectPin: 'Select NIP es',
  hdrPin: 'NIP (Número de Identificación Personal)',
  hdrLogin: 'Iniciar sesión',
  hdrProviderLogin: 'Proveedores Iniciar sesión',
  hdrHome: 'Inicio',
  hdrMyBenefits: 'Mis Beneficios',
  hdrDigitalCard: 'Tarjeta digital',
  hdrMyHealth: 'Mi salud',
  hdrMyHealthSummary: 'Mi Resum de Salud',
  hdrHealthSummary: 'Mi Resum de Salud',
  hdrMemberResource: 'Recursos',
  hdrAlerts: 'Mensajes',
  hdrBroadCastAdmin: 'Vista previa de mensajes',
  hdrBroadCastMessage: 'Vista previa de mensajes',
  hdrMyProvider: 'Mis Proveedores',
  hdrMyFavorites: 'Mis Favoritos',
  hdrFindProvider: 'Mis Proveedores',
  hdrUploadFile: 'Enviar a agencia',
  hdrError: 'Error',
  AppTitle: '<AppName>',
  errLoginUsrReq: 'Ingrese el nombre de usuario',
  errLoginUsrMinReq: 'Por favor, ingrese al menos 8 caracteres para el Nombre de usuario',
  errLoginUsrMaxReq: 'Por favor, limite a máximo de 20 caracteres para el Nombre de usario',
  errLoginPasReq: 'Por favor, ingrese contraseña',
  errLoginPasMinReq: 'Ingrese al menos 6 caracteres para la contraseña',
  errLoginPasMaxReq: 'Limitar la contraseña a un máximo de 12 caracteres',
  errLoginPassOnlyNum: 'La contraseña no debe contener caracteres.',
  errLoginPasAlpReq:
    'Por favor Incluya al menos un carácter de números, letras mayúsculas y minúsculas mixtas y caracteres especiales para la contraseña',
  errRegisFirNamReq: 'Ingrese su primer Nombre',
  errRegisFirMaxReq: 'Limite primer Nombre a un máximo de 40 caracteres',
  errRegisLasNamReq: 'Ingrese su apellido',
  errRegisLasMaxReq: 'Limite Apellido a un máximo de 40 caracteres',
  errRegisConUsrReq: 'Confirme su Nombre de usuario',
  errRegisConUsrMinReq: 'Ingrese al menos 8 caracteres para Confirmar nombre de usuario',
  errRegisConUsrMaxReq: 'Limite a un maximo de 20 caracteres el Nombre de usuario para confirmar',
  errRegisConUsrMisReq:
    'Por favor asegúrese de que coincide el Nombre de usuario con el Nombre de usuario a confirmar',
  errRegisConPasReq: 'Ingrese contraseña para confirmar',
  errRegisConPasMisReq:
    'Por favor, asegúrese de que la contraseña es igual a la contraseña para confirmar',
  errRegisMobileReq: 'Ingrese el número de móvil',
  errRegisMobileOnlyNumber: 'Ingrese solo el número',
  errRegisMobileValid: 'Ingrese un número de móvil válido',
  errRegisMedIDReq: 'Ingrese su ID global o ID de miembro',
  errRegisMedID: 'Ingrese el ID de miembro',
  errRegisMemberIDMaxReq: 'Limite el ID de miembro a un máximo de 20 caracteres',
  errRegisMedIDMaxReq:
    'Limite el Número de Seguro Social o ID de miembro a un máximo de 20 caracteres',
  errRegisDatReq: 'Ingrese fecha de nacimiento',
  errRegisDatVal: 'Ingrese fecha de nacimiento en el formato DD/MM/AAAA',
  errValidDOB: 'Ingrese una fecha de nacimiento válida.',
  errInvalidAuth: 'Ingrese un código de verificación válido',
  errIncorrectDOB: 'Ingrese fecha de nacimiento correcta.',
  errSelectFM: 'Por favor, seleccione un miembro de la familia',
  errRegisCapchaVal: 'Haga clic en el texto "No soy un robot"',
  errValPinMisMat: 'Ingrese NIP correcto',
  errValPinMisMatWarning:
    'Por favor, note que su cuenta podría ser deshabilitada debido a demasiados intentos sin éxito',
  errValPinMisMatError:
    'Su cuenta está deshabilitada debido a demasiados intentos fallidos. Vuelva a registrarse para habilitar su cuenta.',
  errPinMisMat: 'Por favor asegúrese de que coincidan los números de NIP',
  errEnterSamePin: 'El nuevo NIP no puede ser el mismo que el NIP actual',
  errServerNoRecordFound:
    'No se puede localizar su registro. Por favor, inténtelo de nuevo con información precisa o contactenos para obtener más ayuda',
  errServerUnableUpdateCard:
    'No se puede actualizar la información del afiliado. Por favor, revise la lista de errores para mayor información.',
  errServerInvalidCredentials:
    'Por favor asegúrese de que está ingresando el Nombre de usuario y contraseña correctos. Si necesita recuperarlos, por favor haga clic en Olvidé mi contraseña.',
  errServerPageNotFound:
    'La página no es disponible. Por Favor, trate de nuevo más tarde o Contáctenos para más ayuda.',
  errServerInternalError:
    'No es posible procesar su solicitud.  Por favor, trate de nuevo más tarde o Contáctenos para más ayuda.',
  errServerAuthorizationDenied:
    'No es posible procesar su solicitud.  Por favor, trate de nuevo más tarde o Contáctenos para más ayuda.',
  errGeneralMessage:
    'No es posible procesar su solicitud.  Por favor, trate de nuevo más tarde o Contáctenos para más ayuda.',
  errConnectionTimedOut:
    'No se puede comunicar con el servidor. Por favor, inténtelo de nuevo más tarde o Contactenos para obtener más ayuda.',
  errDigitalCardRetriveFMC:
    'No se puede verificar la información proporcionada. Por favor, inténtelo de nuevo con información precisa o póngase en contacto con nosotros para obtener más ayuda.',
  errorSessionTimeout: 'Tu sesión ha expirado.',
  errServerUsernameExist: 'Por favor, selecto un ombre de usuario diferente',
  errUpdateMemberAccess: 'Se produjo un error al recuperar mensajes. Por favor inténtalo de nuevo.',
  errNoResponse: 'No hay respuesta del servidor',
  errValEmailReq: 'Ingrese la dirección de correo electrónico',
  errValEmailminlength: 'Ingrese al menos 5 caracteres para el correo electrónico',
  errValEmailmaxlength: 'Limite correo electrónico a un máximo de 40 caracteres.',
  errValidEmail: 'Ingrese una dirección de correo electrónico válida.',
  errNoChangeInEmail: 'Ingrese un nuevo correo electrónico para cambiar correo electrónico',
  errNoChangeInPhone: 'Ingrese un nuevo número para cambiar número de teléfono',
  errSharedMemIDReq: 'Ingrese número de identificación del miembro.',
  errSharedMemIDMaxReq: 'Limite ID de Medicaid a un máximo de 20 caracteres',
  errSharedOTPReq: 'Por favor,ingrese condigo comparyido por el miembro.',
  errSharedOTPExpired: 'Una contraseña de tiempo caducó. Obtenga una nueva contraseña del miembro.',
  errSharedOTPConsumed:
    'Una contraseña de tiempo no puede ser reutilizada. Obtenga una nueva contraseña del miembro.',
  errSharedOTPNotValid:
    'La contraseña de una hora no es válida. Obtenga una nueva contraseña del miembro.',
  errFileNotAvailable:
    'No se puede mostrar documento. Inténtelo de nuevo más tarde o póngase en contacto con nosotros para obtener más ayuda.',
  errConnectivityIssue:
    'Incapaz de proporcionar respuestas en este momento. Por favor intente de nuevo más tarde o contáctenos para asistencia adicional.',
  errEnterValidFirstName: 'Ingrese un primer nombre válido',
  errEnterValidLastName: 'Ingrese un apellido válido',
  errCannotMakeCall: 'Su dispositivo no es compatible con la funcionalidad de llamada',
  errURLNotSupported: 'URL no es compatible',
  errLocationReq: 'Ingrese ubicación',
  errValidLocationReq: 'Ingrese ubicación válida',
  errDistanceReq: 'Ingrese Distancia',
  errProviderTypeReq: 'Ingrese el Tipo de Proveedor',
  errSpecialtyReq: 'Ingrese la Especialidad',
  errProviderNameReq: 'Ingrese nombre del proveedor',
  errValidProviderName: 'Ingrese nombre de proveedor válido',
  errRegisMessageAdminMaxReq: 'Por favor, limite a 255 caracteres',
  errFavoriteLimit: 'Favorito excede el límite, elimina cualquier favorito y guarda otro',
  errTotalHrsWorked: 'Ingrese nombre del empleador',
  errEmployerName: 'Please enter employer nameIngrese nombre del empleador ',
  errEmployerAddress: 'Ingrese dirección del empleador',
  errEmployerCity: 'Ingrese cuidad del empleador',
  errEmployerZip: 'Ingrese codigo postal del empleardor',
  errBusinessName: 'Ingrese Nombre del Negocio',
  errBusinessNameLength: 'Nombre de empresa debe ser inferior a 40 caracteres',
  errBusinessAddressLength: 'Dirección debe tener menos de 256 caracteres',
  errBusinessCityLength: 'Ciudad debe tener menos de 40 caracteres.',
  errBusinessStateLength: 'Estado debe tener menos de 40 caracteres',
  errBusinessZipLength: 'Condigo Postal debe tener menos de 10 caracteres',
  errDuplicateBusiness:
    'No se puede agregar una empresa duplicada, ya ha agregado <NOMBRE DE LA EMPRESA>',
  lblMemberBenefits: 'Miembro Beneficios',
  errNoCurrentAddress: 'No hay dirección disponible',
  errAddress1: 'Ingresa dirección 1',
  errAddress1Length: 'Dirección 1 debe ser menos a 256 caracteres',
  errAddress2Length: 'Dirección 2 debe ser menos a 256 caracteres',
  errCity: 'Ingrese Ciudad',
  errCityLength: 'Ciudad debe ser menos a 40 caracteres',
  errState: 'Por favor, seleccione Estado',
  errStateLength: 'Estado debe tener menos de 40 caracteres',
  errZip: 'Ingrese Condigo Postal',
  errZipLength: 'Condigo Postal debe tener menos de 10 caracteres',
  errDateMisMatch: 'La Fecha de inicio debería ser menos que la fecha de finalización',
  errDrugNameMinReq: 'Ingrese al menos 2 caracteres para el nombre del medicamento',
  errDrugNameMaxReq: 'Por favor, limite el nombre del medicamento a un máximo de 20 caracteres',
  errDrugClassMinReq: 'Introduzca al menos 2 caracteres para la clase de fármaco',
  errDrugClassMaxReq: 'Limite la clase de fármaco a un máximo de 20 caracteres',
  errDrugNameReq: 'Ingrese el nombre del medicamento',
  errDrugClassReq: 'Introduzca la clase de fármaco',
  lblSecureCodeSentToRegMob: 'Se ha enviado el código de verificación a su móvil registrado',
  lblSecureCodeSentToRegEmail:
    'Código de verificación ha sido enviado a su correo electrónico registrado',
  lblSecureCodeSentSuccessfully: 'Código de verificación se envió correctamente.',
  lblLoginUsrNam: 'Nombre de usuario',
  lblLoginPas: 'Contraseña',
  lblLoginForPas: 'Olvidó contraseña',
  lblLoginReg: 'Registro',
  lblLoginRememberMe: 'Recuérdame',
  lblRegisterFirNam: 'Nombre',
  lblRegisterLasNam: 'Apellido',
  lblRegisterDob: 'Fecha de nacimiento (MM/DD/AAAA)',
  lblRegisterSSNo: 'Número de seguro social',
  lblMedicadId: 'Número de identificación del miembro o número de seguro social',
  lblRegisterNext: 'Siguiente',
  lblRegisterConUsrNam: 'Confirme Nombre de usuario',
  lblRegisterOptTFA: 'Verificación en 2 pasos:',
  lblRegisterMobileNo: 'Móvil',
  lblEmail: 'Correo electrónico',
  lblAuthCodeSent: 'Código de autorización se ha enviado a su móvil',
  lblRegisterPass: 'Contraseña',
  lblRegisterConPass: 'Confirmar contraseña',
  lblSubmit: 'Enviar',
  lblPinReEnt: 'Confirmar NIP',
  lblSendOTP: 'Seleccione la siguiente opción para recibir el código:',
  lblOTPSendText1: 'Código de verificación ha sido enviado a',
  lblOTPSendText2: 'Codigo expira en # minutos',
  lblBtnOTPSend: 'Enviar código',
  lblBtnResendCode: 'Reenviar codigo',
  lblVerifyCodeText: 'Ingrese código de verificación:',
  lblValPinHeading: 'Identificación de Medicaid',
  lblValPinHead1: 'Ingrese su PIN de 4 dígitos',
  lblLangSubmit: 'Confirm / Confirmar',
  lblLogout: 'Cerrar session',
  lblPrint: 'IMPRIMIR',
  lblOR: 'O',
  lblFamilyMemberCard: 'Tarjeta del familiar',
  lblMyCard: 'Mi Tarjeta',
  lblGenerateCard: 'Generar Tarjeta',
  lblTermsAgree:
    'Al hacer clic en Enviar, acepta recibir comunicaciones digitales. Una vez registrado, puede optar por no participar en cualquier momento a través de una función del menú de la aplicación.',
  lblTermsCondition: 'Términos de servicio',
  lblShow: 'MOSTRAR',
  lblHide: 'ESCONDER',
  lblClose: 'Cerrar',
  lblBack: 'Regreso',
  lblIssuedOn: 'Publicado en: ',
  lblStartDate: 'Fecha de inicio: ',
  lblEndDate: 'Fecha final: ',
  lblBeneficiaryNotEligible: 'El beneficiario no es elegible',
  lblCardNotValid: 'Tarjeta no activa',
  lblMedicaidOrSSN: 'ID de miembro o número de seguro social',
  lblDigitalCardRefresh: 'Por favor inicie sesión para actualizar su tarjeta digital.',
  lblAutoRefreshCredential: 'Por favor inicie sesión para actualizar el contenido de esta página.',
  lblDigitalCardAutoRefresh: 'Actualizar tu tarjeta…',
  lblAlertAutoRefresh: 'Actualizando tus mensajes...',
  lblDate: 'Fecha: ',
  lblExpires: 'Expiración: ',
  lblNoNewAlert: 'No hay mensajes nuevos',
  lblNewAlerts: 'Nuevos mensajes disponibles',
  lblNoAlert: 'No hay mensajes',
  lblNoMemRes: 'No hay recursos disponibles',
  lblProviderOTP: 'Generar contraseña única',
  lblMemberID: 'Identificación de miembro',
  lblSharedOTP: 'Contraseña una vez (OTP)',
  lblProviderLogin: 'Iniciar session',
  lblProviderDate: 'Impreso en',
  lblProviderIp: 'IP',
  lblProviderEmail: 'correo electrónico',
  lblStart: 'Iniciar: ',
  lblID: 'ID: ',
  lblEnd: 'Fin: ',
  lblStatus: 'Estado: ',
  lblMedicaidIDStatusNotValid: 'Su estado de identificación de Medicaid está inactivo',
  lblProgram: 'Programa: ',
  lblDOB: 'Fecha de nacimento: ',
  lblProgramCaseNumber: 'Su número de caso es ',
  lblNeedHelp: 'Necesitas Ayuda',
  lblyou: 'Tú: ',
  lblSupport: 'Asistente de soporte: ',
  lblSend: 'Enviar',
  lblAskQuestionPlaceholder: 'Escribe tu mensaje aquí…',
  lblMemberInactive: 'Miembro inactivo',
  lblHello: 'Hola,',
  lblLoading: 'cargando...',
  lblAppointment: 'Cita: ',
  lblCalendarSave: 'Cita guardada correctamente.',
  lblCalendarCancel: 'Cita no guardada. Por favor inténtelo de nuevo.',
  lblCalendarError: 'Cita no guardada. Por favor conceda permiso para acceder a su calendario.',
  lblNotValidLink: 'URL no es compatible',
  lblNotValidPDFLink: 'PDF no es compatible',
  lblNotOpenDatePicker: 'No se puede abrir el selector de fecha',
  lblBroadcastDate: 'Fecha de transmisión',
  lblApprove: 'Aprobar',
  lblReject: 'Rechazar',
  lblApproved: 'Aprobado',
  lblRejected: 'Rechazado',
  lblBroadCastSend: 'Transmisión Enviar',
  lblBroadcastFailure: 'Transmisión falló',
  lblLocation: 'Ubicación *',
  lblDistance: 'Distancia (millas) *',
  lblProviderType: 'Tipo de proveedor *',
  lblSpecialty: 'Especialidad',
  lblSearchProvider: 'Encontrar',
  lblProviderName: 'Nombre del proveedor',
  lblProvidersSearchResults: 'Proveedores <count> Encontrados',
  lblNoProvidersSearchResults: 'No hay proveedores disponibles',
  lblPcpTitle: 'Mi PCP',
  lblNoPcp:
    'No ha seleccionado un PCP. Puede seleccionar uno de los resultados de búsqueda del proveedor.',
  lblChoosePcp: 'Seleccion PCP',
  lblPcpSelected: 'Mi PCP',
  lblCommentApprove: 'Estás aprobando el mensaje.',
  lblCommentReject: 'Estás rechazando el mensaje.',
  lblValuableComment: 'Revisar comentarios',
  lblUserComment: 'Ingrese su comentarios',
  lblCancel: 'Cancelar',
  lblValidate: 'Verificar',
  lblYes: 'Sí',
  lblNo: 'No',
  lblExitHead: 'Salir de MyARMedicaid',
  lblExitText: 'Quieres salir de MyARMedicaid?',
  lblFavoriteResults: 'Número de favoritos: <count>',
  lblNoFavorite: 'No hay favoritos disponibles',
  lblOptOutMsg:
    'Las comunicaciones en papel se reanudarán y ya no recibirá más información sobre esta aplicación.',
  lblAfterOptOutMsg:
    'Si desea volver a registrarse en esta aplicación en el futuro, vuelva a registrarse en la aplicación.',
  lblOptOutResponseAlertTitle: 'Exitoso',
  lblOptOut: 'Optar por no',
  lblReset: 'Reiniciar',
  lblClear: 'Borrar',
  lblAddDetails: 'Detalles de Dirección',
  lblResetPIN: 'Restablecer NIP',
  hdrPinHeadingPinOnly: 'Ingrese el NIP',
  hdrPinHeadingFingerPrint: 'Ingrese el NIP O use el reconocimiento de rostro / huella digital',
  lblCurrentAdd: 'Direccion Actual',
  lblModifyAdd: 'Nueva/Modificar Dirección',
  lblAddress1: 'Dirección 1',
  lblAddress2: 'Dirección 2',
  lblCity: 'Ciudad',
  lbState: 'Estado',
  lblZip: 'Codigo Postal',
  lblAge: 'Age',
  lblYear: 'Years',
  lblMonths: 'Months',
  lblGender: 'Sexo',
  lblOptOutSuccessMsg: 'Usted ha sido excluido de MyARMedicaid',
  lblOpenInMap: 'Abrir en el mapa',
  lblProfSetting: 'Configuración de perfil',
  lblSelectTimeFrame: 'Seleccionar marco de tiempo:',
  lblClaims: 'Reclamar',
  lblProcedures: 'Procedimientos',
  lblProcedureName: 'Nombre del procedimiento',
  lblImmunizations: 'Vacunas',
  lblPrescriptions: 'Recetas',
  lblProvidersSeen: 'Proveedores vistos',
  lblProvider: 'Proveedor:',
  lblClaimNo: 'Reclamar No:',
  lblName: 'Nombre:',
  lblProCode: 'Provedor código:',
  lblDrugName: 'Droga Nombre:',
  lblDosage: 'Dosis:',
  lblPhone: 'Telefono:',
  lblView: 'Ver',
  lblDownload: 'Descargar',
  lblDataDownloaded: 'Periodo de tiempo: ',
  lblDataDownload: 'Descargado en: ',
  lblExternalLinks: 'Enlaces externos',
  lblViewSharedCard: 'Ver tarjeta compartida',
  lblViewHealthSummary: 'Ver resumen de salud',

  hdrNeedHelp: 'Como puedo ayudarte?',
  hdrLoginHeading: 'Por favor Iniciar sesión',
  hdrRegisterHeading: 'Por favor ingrese su información de inscripción',
  hdrRegisterHeadingPage2: 'Por favor, elija su información de inicio de sesión',
  hdrRegisterHeadingPassword: 'Por favor elige tu contraseña',
  hdrDigCardHeading: 'Tu tarjeta',
  hdrDigCardHeadingSelectCard: 'Seleccione la tarjeta',
  hdrDigCardFamilyMember: 'Por favor, seleccione un miembro de la familia',
  hdrDigCardMember: 'Tarjeta de <first name>',
  hdrPinHeading: 'Por favor, elija un número de 4 dígitos para su contraseña',
  hdrVerifyMFA: 'Verificación de dos pasos',
  hdrSetupMFA: 'Configurar la verificación en dos pasos',
  hdrPinHead1:
    'Estos 4 dígitos de su contraseña serán requeridos para validar su acceso cada vez que usted abra esta aplicación.',
  hdrValPinHead1: 'Por favor, introduzca su PIN de 4 dígitos',
  hdgNoInternetHeading:
    'El dispositivo no tiene acceso a Internet ahora. Por favor, inténtelo de nuevo una vez conectado a Internet.',
  hdgNoInternetHeading2:
    'Su dispositivo está desconectado, se requiere una conexión a Internet para que se muestren los datos',
  hdrLanguageHeading: 'Language / Idioma',
  hdrLanguageSubHeading: 'Elige Lengua',
  hdrShareCardHeading: 'Compartir Tarjeta',
  hdrShareCardOTP: 'Contraseña una vez (OTP) : ',
  hdrShareCardOTPExpiry: 'OTP de caducidad :',
  hdrShareCardText:
    'También puede enviar la información de acceso al proveedor de servicios por correo electrónico si así lo solicita.',
  hdrShareCardHeadText:
    'Por favor, genere una contraseña de una sola vez y luego comparta la información mostrada con el proveedor de servicios.',
  hdrShareCardHeadOTPText: 'Por favor compartan información mostrada con su proveedor de servicios',
  hdrShareCardMemID: 'Id de miembro : ',
  hdrShareCardSendEmail: 'Enviar Correo Electrónico',
  hdrShareCardDone: 'Terminado',
  hdrShareCardTitle: 'Compartir la tarjeta de <primer nombre>’s',
  hdrShareCardInform: 'Se ha enviado información de acceso a <primer nombre>',
  hdrProviderMemberCardHeading: 'Tarjeta de MyARMedicaid de <primer nombre>',
  hdrProviderHeading: 'Ver la tarjeta de identificación de MyARMedicaid',
  hdrBrowserNotSupport: 'Su navegador no admite este sitio web.',
  hdrFormulary: 'Formulario',
  hdrUploadingFile: 'Cargando Archivos',
  hrdTimeTracker: 'Rastreador de tiempo',
  lblTimeTrackerSummary: 'Horas totales trabajadas - <count>',
  hdrBusinessDetails: 'Detalles del negocio',
  cntRegisterPasswordHint:
    'Contraseña debe tener  de 8-12 caracteres y contener números y letras mayúsculas y minúsculas',
  cntDigCardLastStored: 'Ultima descarga de la Tarjeta en',
  cntDigCardOfflineBefore:
    'Para nuevas actualizaciones a esta tarjeta de MyARMedicaid, Por favor seleccione la opción enviar al menu',
  cntDigCardOfflineAfter: 'en la parte superior y capture su Nombre de Usuario y Clave de Entrada.',
  uploadReceipt: 'Listado de archivos',
  lblFileSizeExceeds: 'El tamaño del archivo que está enviando excede <tamando del archivo>',
  lblNotValidFileFormate: 'No un formato del archivo valido',
  lblCamera: 'Cámara',
  lblProcessing: 'Tratamiento',
  lblFileUploading: 'Carga de archivos',
  lblPartialUpload: 'Pocos archivos han sido enviados',
  lblUploadSubHeader: 'Número de archivo (s) a enviar: <count>',
  lblDeleteExtraFile1: 'Solo puedes subir archivos <count>',
  lblModuleId: 'ID de modulo',
  lblTimeTrackerID: 'ID de rastreador de tiempo',
  hdrTimeTrackerFileUpload: 'Rastreador de tiempo - Docs',
  lblUploads: 'Cargandos',
  lblUploadDocCurrentWeek: 'Camprobantes',
  lblTimeTrackerFileUploadPara: 'Está cargando documentos para el intervalo de fechas seleccionado',
  lblDeleteExtraFile2: ' Por favor, elimine archivos adicionales y cargue',
  lblFileUploadedSuccessfully: 'Enviar con éxito los archivos',
  lblAddMore: 'Añadir',
  lblSendToAgencyPara:
    'Aceptamos imágenes y documentos PDF de <FILE_SIZE> o menos en tamaño. Puede enviar un máximo de archivos <FILE_LIMIT> a la vez',

  lblOk: 'OK',
  lblFileListingPara:
    'Seleccione los documentos/imágenes que desea enviar a la agencia haciendo clic debajo del botón Añadir',

  lblTotalHrsWorked: 'Total de horas trabajaras',
  lblEmployerName: 'Nombre de Empresa',
  lblEmployerAddressSection: 'Dirección de Empresa',
  lblEmployerAddress: 'Dirección',
  lblEmployerCity: 'Ciudad',
  lblEmployerZip: 'Codigo Postal',
  lblTimeTrackerHeader: 'Por favor ingrese el tiempo',
  lblBusinessName: 'Nombre del Empresa',
  lblBusinessAddress: 'Dirección',
  lblBusinessCity: 'Ciudad',
  lblBusinessState: 'Estado',
  lblBusinessAdd: 'Añadir Empresa',
  lblDiscard: 'Deschar',
  hdrCameraRollTitle: 'Las fotos',
  lblValidHours: 'Por favor ingrese las Horas válidas.',
  lblHourExceeded: 'Total de horas superan las 24 horas.',
  lblDiscarded: 'Descartar los cambios',
  lblTimeTrackerSuccessMsg: 'Entradas de tiempo guardadas',
  lblHours: 'Horas',
  weekDay1: 'Lun',
  weekDay2: 'Mar',
  weekDay3: 'Mie',
  weekDay4: 'Jue',
  weekDay5: 'Vie',
  weekDay6: 'Sab',
  weekDay7: 'Dom',
  hdrTimeTrackerSummary: 'Resumen Semanal',
  lblSelectDateRange: 'Seleccione intervalo de fechas',
  lblSelectDateRangeSummary: 'Seleccione intervalo de fechas',
  lblSelectBusiness: 'Seleccione la Empresa',
  lblTotalHours: 'Horas Totales: ',
  lblPermission: 'MyARMedicaid requiere acceso a su cámara y almacenamiento. Desea continuar?',
  lblPermissionLocation: 'MyARMedicaid requiere acceso a su ubicación. Desea continuar?',
  lblImageGallery: 'Galería de imágenes',
  lblPdfDocument: 'Documento de PDF',
  lblOptOutAlertTitle: 'Quieres proceder?',
  lblCalendarSaveEventError: 'Guardar el error de event',
  lblPermissionCalendar: 'MyARMedicaid requiere acceso a su calendario Desea Continuar?',
  lblValPinReset: 'Por favor ingrese un nuevo NIP',
  lblPinResetSuccess: 'El NIP se actualizó con éxito',
  lblCloseApp: 'Cerrar la Tarjeta',
  lblOptedOut: 'Optó por',
  addressUpdateSuccess: 'Dirección actualizada con éxito',
  LocaleUpdateSuccess: 'Idioma actualizado con éxito',
  lblPageNotFound: 'Página no encontrada',
  lblFingerPrint:
    'Escanee su rostro registrado o huella digital en el escáner del dispositivo para continuar',
  lblEmailTimer: 'El código de verificación venció para correo electrónico',
  lblMobileTimer: 'Otp expiró para dispositivos móviles',
  lblEmailMobileTimer: 'Otp expiró tanto para dispositvos correo electrónico / móvil',
  lblBtnMFAStop: 'Discontinuar',
  lblStopMFA: 'Detener la verificación en dos pasos',
  lblActivatePhone: 'Activar Móvil',
  lblActivateEmail: 'Activar El Correo Electrónico',
  lblConfirmStopMFA:
    'Ya no podrás proteger la aplicación con la verificación en dos pasos. Está seguro, quieres descontinuar?',
  lblStopPhone:
    'Ya no podrá recibir el código de verificación en el móvil. Está seguro de que desea inactivar teléfono?',
  lblStopEmail:
    'Ya no podrá recibir el código de verificación por correo electrónico. Está seguro de que desea inactivar correo electrónico?',
  lblOptedOutMFA: 'Configurar la verificación en dos pasos',
  lblMFAControllerInfo: 'Haga clic en el botón azul de la lupa para autenticarse',
  lblBtnMFAComplete: 'Configuración completa',
  lblStartPhone:
    'Comenzará a recibir el código de verificación en teléfono registrado. Haga clic en SÍ para activar el teléfono',
  lblStartEmail:
    'Comenzará a recibir el código de verificación en correo electrónico registrad. Haga clic en SÍ para activar el correo electrónico',
  lblSomethingWentWrong: 'Algo salió mal. Por favor, vuelva a intentarlo!',
  lblEmailIsDeactivated:
    'Correo electrónico ya está desactivado. Haga clic en el botón Discontinuar para detener la verificación en dos pasos',
  lblPhoneIsDeactivated:
    'Teléfono ya está desactivado, haga clic en el botón Discontinuar para detener la verificación en dos pasos',
  lblSkip: 'Saltar a casa',
  lblMedicalConditions: 'Nombre de la droga',
  hdrFetchedInfo: 'Información obtenida',
  lblDrugClass: 'Clase de droga',
  lblBtnGoToHome: 'Ir a casa',
  lblSymptoms: 'Symptoms',
  lblPrice: 'Price',
  lblSearchDrug: 'Buscar medicamentos',
  lblDrugTypes: 'Select Drug Type',
  lblUsed: 'Used',
  lblDrugList: 'Drug List',
  lblDrugSearchResults: 'Drug Search Results',
  lblMfaSetupCompleted:
    'Ha configurado correctamente la verificación en dos pasos. Por favor continúe a casa.',
  lblBrowserPermission: 'Habilite su permiso de notificación en el navegador',
  lblPendingMembership:
    'Su estado de membresía es Pendiente. El acceso completo se otorgará tras la aprobación.',
  lblGlobalID: 'ID global',
  lblVersionNumber: 'Versión No:',
  hrdDigitalCard:
    'Se requiere la identificación de miembro y la contraseña de un solo uso (OTP) compartida por el miembro para ver su tarjeta digital',
  hrdHealthSummary:
    'Se requiere la identificación de miembro y la contraseña de un solo uso (OTP) compartida por el miembro para ver su resumen de salud',
  lblPopupHeader1: 'Está seguro de que desea cerrar esta tarjeta digital?',
  lblPopupHeader2:
    'Si presiona el botón Aceptar, no podrá ver / imprimir esta tarjeta nuevamente hasta que obtenga una nueva OTP del miembro',
  lblPopupHealthSummaryHeader1:
    'Está seguro de que desea cerrar el Resumen de salud de este miembro?',
  lblPopupHealthSummaryHeader2:
    'Si presiona el botón Aceptar, no podrá descargar / imprimir este resumen de salud nuevamente hasta que obtenga una nueva OTP del miembro',
  errFileNameDoesNotExists:
    'Algo salió mal con el Informe de resumen de salud; solicite al miembro que busque en sus registros de salud y lo comparta nuevamente.',
  errPermissionDenied:
    'Algo salió mal con el Informe de resumen de salud; solicite al miembro que busque en sus registros de salud y lo comparta nuevamente.',
  errAccessCodeNotValid:
    'OTP no válida: verifique si ha ingresado la OTP correctamente. Además, puede pedirle al miembro que busque en su registro de Resumen de salud y lo comparta nuevamente.',
  errAccessCodeExpired:
    'La OTP ya venció; pídale al miembro que busque en su registro de resumen de salud y lo comparta nuevamente.',
  errAccessCodeConsumed:
    'La OTP ya se ha consumido; solicite al miembro que busque en su registro de resumen de salud y lo comparta de nuevo.',
  errAccessCodeNotValidCard:
    'OTP no válida: verifique si ingresó la OTP correctamente. Además, podrá solicitarle al Socio que vuelva a compartir su tarjeta.',
  errAccessCodeExpiredCard:
    'La OTP ya expiró; solicite al miembro que comparta su tarjeta nuevamente.',
  errAccessCodeConsumedCard:
    'La OTP ya se ha consumido; solicite al miembro que comparta su tarjeta nuevamente.',
  lblAccessibilityEnabled: 'MyARMedicaid la aplicación ahora tiene accesibilidad habilitada',
};
